import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CompanyActions } from '../../../store/actions/companies';
import {
  fetchVoicebotInstances,
  createVoicebotInstance,
  updateVoicebotInstance,
} from '../../../store/actions/voice-bots';

import ModalCreateVoicebotInstance from './ModalCreateVoicebotInstance';
import ModalUpdateVoicebotInstance from './ModalUpdateVoicebotInstance';

import * as S from './styles';

import iconAdd from '../../../assets/images/icon_add.svg';

const VoicebotSettings = () => {
  const [isOpenedModal, setIsOpenedModal] = useState('');
  const [updatingInstance, setUpdatingInstance] = useState({});

  const { signedUser } = useSelector((state) => state.users);
  const { organizations } = useSelector((state) => state.companies);
  const { voicebotInstances } = useSelector((state) => state.voiceBot);

  const dispatch = useDispatch();

  useEffect(() => {
    if (signedUser) {
      if (!organizations || organizations.length === 0) {
        dispatch(
          CompanyActions.getOrganizations({
            companyId: signedUser.selectedCompany._id,
          })
        );
      }
    }
  }, []);

  useEffect(() => {
    if (signedUser?.selectedOrganization) {
      const organizationId = signedUser.selectedOrganization;
      dispatch(fetchVoicebotInstances({ organizationId }));
    }
  }, [signedUser?.selectedOrganization]);

  const organizationsFromSelectedCompany = useMemo(() => {
    if (!signedUser.selectedCompany?._id || !organizations) return [];

    return organizations.filter(
      ({ companyId }) => companyId === signedUser.selectedCompany?._id
    );
  }, [signedUser.selectedCompany?._id, organizations]);

  const handleCreateVoicebotInstance = (instance) => {
    dispatch(createVoicebotInstance(instance, () => setIsOpenedModal('')));
  };

  const handleOpenUpdateModal = (instance) => {
    setUpdatingInstance(instance);
    setIsOpenedModal('update-instance');
  };

  const handleUpdateVoicebotInstance = (instance) => {
    dispatch(
      updateVoicebotInstance(instance, () => {
        setIsOpenedModal('');
        setUpdatingInstance({});
      })
    );
  };

  return (
    <S.VoicebotInstanceWrapper>
      <S.VoicebotInstanceList>
        {voicebotInstances?.map((instance) => (
          <S.VoicebotInstance key={instance._id}>
            <div className="info">
              <span className="name">{instance.name}</span>
              <span className="base-url">{instance.baseUrl}</span>
            </div>

            <button
              type="button"
              onClick={() => handleOpenUpdateModal(instance)}
            >
              editar
            </button>
          </S.VoicebotInstance>
        ))}
      </S.VoicebotInstanceList>

      {isOpenedModal === 'create-instance' && (
        <ModalCreateVoicebotInstance
          organizations={organizationsFromSelectedCompany}
          isOpen={isOpenedModal === 'create-instance'}
          onClose={() => setIsOpenedModal('')}
          onSubmit={handleCreateVoicebotInstance}
        />
      )}

      {isOpenedModal === 'update-instance' && (
        <ModalUpdateVoicebotInstance
          initialData={updatingInstance}
          organizations={organizationsFromSelectedCompany}
          isOpen={isOpenedModal === 'update-instance'}
          onClose={() => {
            setIsOpenedModal('');
            setUpdatingInstance({});
          }}
          onSubmit={handleUpdateVoicebotInstance}
        />
      )}

      <img
        className="button-create"
        src={iconAdd}
        alt="Icon add"
        onClick={() => setIsOpenedModal('create-instance')}
      />
    </S.VoicebotInstanceWrapper>
  );
};

export default VoicebotSettings;
